@if (!isIframe) {
  <div flexLayout="column" flexLayoutAlign="start stretch" class="wrapper">
    <vp-top-nav-shell></vp-top-nav-shell>
    <vp-system-banner></vp-system-banner>
    <div flex>
      @if (!isIframe) {
        <router-outlet></router-outlet>
      }
    </div>
    <vp-bottom-nav-shell class="bottom-nav"></vp-bottom-nav-shell>
    @if (!isProd) {
      <vp-security-popup class="floating"></vp-security-popup>
    }
  </div>
}
